interface HvacAssetRow {
  name: string | null;
  estimated_age_years: number | null;
  category_attributes: unknown;
  category_id?: string | null;
  asset_categories?: { name: string | null } | null | { name: string | null }[];
}

/** Sum tonnage and find oldest age across HVAC-like assets for a property. */
export function computeHvacTonnage(rows: HvacAssetRow[] | null | undefined): {
  hvacTonnageInstalled: number | null;
  oldestHvacUnitAgeYears: number | null;
} {
  let hvacTonnageInstalled: number | null = null;
  let oldestHvacUnitAgeYears: number | null = null;

  // Filter for HVAC assets in JS memory to handle dynamic category mappings
  const filtered = (rows ?? []).filter((a) => {
    const cat = Array.isArray(a.asset_categories) ? a.asset_categories[0] : a.asset_categories;
    const catName = (cat?.name as string | undefined) || "";
    const nameLower = (a.name || "").toLowerCase();
    return (
      catName.toLowerCase().includes("hvac") ||
      catName.toLowerCase().includes("refrigeration") ||
      nameLower.includes("hvac") ||
      nameLower.includes("rtu") ||
      nameLower.includes("air condition") ||
      nameLower.includes("cooling") ||
      nameLower.includes("heat pump") ||
      nameLower.includes("ac unit") ||
      nameLower.includes("rooftop")
    );
  });

  if (filtered.length === 0) {
    return { hvacTonnageInstalled, oldestHvacUnitAgeYears };
  }

  let total = 0;
  let foundAny = false;
  for (const a of filtered) {
    const attrs = (a.category_attributes as { tonnage?: number | string } | null) || {};
    const tonnage = attrs.tonnage != null ? Number(attrs.tonnage) : null;

    if (tonnage != null && tonnage > 0) {
      total += tonnage;
      foundAny = true;
    } else if (a.name) {
      // Try parsing tonnage from name, e.g. "5 Ton Carrier", "7.5T RTU"
      const match = a.name.match(/(\d+\.?\d*)\s*(?:ton|t\b)/i);
      if (match) {
        total += parseFloat(match[1]);
        foundAny = true;
      }
    }
    // Determine age of unit from the estimated_age_years column
    const ageYears = a.estimated_age_years;
    if (ageYears != null) {
      if (oldestHvacUnitAgeYears === null || ageYears > oldestHvacUnitAgeYears) {
        oldestHvacUnitAgeYears = ageYears;
      }
    }
  }
  if (foundAny) hvacTonnageInstalled = total;

  return { hvacTonnageInstalled, oldestHvacUnitAgeYears };
}
